import { DynamicFieldData } from '@/types/dynamic-control-types';

interface ProductSection<T> {
    title: string;
    fields: T[];
}

interface CreateProduct {
    productInformation: ProductSection<DynamicFieldData>;
    productPricing: ProductSection<DynamicFieldData>;
}

export const createProduct: CreateProduct = {
    productInformation: {
        title: 'Product information',
        fields: [
            {
                fieldName: 'name',
                inputType: 'text',
                label: 'Medicine Name',
                defaultValue: '',
                className: 'col-span-1',
            },

            {
                fieldName: 'shelf',
                inputType: 'text',
                label: 'Shelf',
                defaultValue: '',
                className: 'col-span-1',
            },
        ],
    },

    productPricing: {
        title: 'Product Pricing',
        fields: [
            {
                fieldName: 'purchase_price',
                inputType: 'number',
                label: 'Purchase price (tk.)',
                defaultValue: '',
                className: 'col-span-1',
            },

            {
                fieldName: 'wholesale_price',
                inputType: 'number',
                label: 'Wholesale price (tk.)',
                defaultValue: '',
                className: 'col-span-1',
            },
            {
                fieldName: 'retail_price',
                inputType: 'number',
                label: 'Retail price (tk.)',
                defaultValue: '',
                className: 'col-span-1',
            },
        ],
    },
};

export const createCategoryFields: DynamicFieldData[] = [
    {
        fieldName: 'categoryName',
        inputType: 'text',
        label: 'Category Name',
        defaultValue: '',
        className: 'col-span-1',
    },
    {
        fieldName: 'description',
        inputType: 'text-area',
        label: 'Descrioption',
        defaultValue: '',
        className: 'col-span-1',
    },
];

export const createBrandFields: DynamicFieldData[] = [
    {
        fieldName: 'name',
        inputType: 'text',
        label: 'Brand Name',
        defaultValue: '',
        className: 'col-span-1',
    },
    {
        fieldName: 'description',
        inputType: 'text-area',
        label: 'Descrioption',
        defaultValue: '',
        className: 'col-span-1',
    },
];

export const createUnitFields: DynamicFieldData[] = [
    {
        fieldName: 'name',
        inputType: 'text',
        label: 'Unit Name',
        defaultValue: '',
        className: 'col-span-1',
    },
    {
        fieldName: 'quantity',
        inputType: 'number',
        label: 'Quantity',
        defaultValue: 0,
        className: 'col-span-1',
    },
    {
        fieldName: 'strip_quantity',
        inputType: 'number',
        label: 'Strip Quantity',
        defaultValue: 0,
        className: 'col-span-1',
    },
];

export const createStrengthFields: DynamicFieldData[] = [
    {
        fieldName: 'name',
        inputType: 'text',
        label: 'Strength Name',
        defaultValue: '',
        className: 'col-span-1',
    },
];

export const createTypeFields: DynamicFieldData[] = [
    {
        fieldName: 'name',
        inputType: 'text',
        label: 'Type Name',
        defaultValue: '',
        className: 'col-span-1',
    },
    {
        fieldName: 'status',
        inputType: 'checkbox',
        label: 'Status ',
        defaultValue: '',
        className: 'col-span-1',
    },
];

export const createGeneticFields: DynamicFieldData[] = [
    {
        fieldName: 'name',
        inputType: 'text',
        label: 'Genetic Name',
        defaultValue: '',
        className: 'col-span-1',
    },
    {
        fieldName: 'indications',
        inputType: 'text',
        label: 'Indications',
        defaultValue: '',
        className: 'col-span-1',
    },
];

export const updateVariationField: DynamicFieldData[] = [
    {
        fieldName: 'type_id',
        inputType: 'auto-complete',
        label: 'Type',
        defaultValue: '',
        className: 'col-span-1',
        actionBtn: true,
        actionBtnLabel: 'Add Type',
    },
    {
        fieldName: 'unit_id',
        inputType: 'auto-complete',
        label: 'Unit',
        defaultValue: '',
        className: 'col-span-1',
        actionBtn: true,
        actionBtnLabel: 'Add Unit',
    },
    {
        fieldName: 'strength_id',
        inputType: 'auto-complete',
        label: 'Strength',
        defaultValue: '',
        className: 'col-span-1',
        actionBtn: true,
        actionBtnLabel: 'Add Strength',
    },
    {
        fieldName: 'purchase_price',
        inputType: 'number',
        label: 'Purchase price (tk.)',
        defaultValue: '',
        className: 'col-span-1',
    },

    {
        fieldName: 'wholesale_price',
        inputType: 'number',
        label: 'Wholesale price (tk.)',
        defaultValue: '',
        className: 'col-span-1',
    },
    {
        fieldName: 'retail_price',
        inputType: 'number',
        label: 'Retail price (tk.)',
        defaultValue: '',
        className: 'col-span-1',
    },
];
